var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFinances(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3318 12.1272C18.3318 10.7608 17.1713 9.65649 15.7301 9.65649H14.2702C12.8383 9.65649 11.6685 10.7608 11.6685 12.1272C11.6685 13.1098 12.2861 14.0083 13.2407 14.4013L16.7595 15.8425C17.7141 16.2356 18.3318 17.1247 18.3318 18.1167V18.2384C18.3318 19.6047 17.1713 20.709 15.7301 20.709H14.2702C12.8383 20.709 11.6685 19.6047 11.6685 18.2384",
    stroke: "#EE2F4B",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0005 7.52246V9.4129",
    stroke: "#EE2F4B",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0005 20.9333V22.4775",
    stroke: "#EE2F4B",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinances);
export default __webpack_public_path__ + "static/media/Finances.4f441ff201441ccb7a6c658e2c4e3f4a.svg";
export { ForwardRef as ReactComponent };